import { PureComponent } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import styles from './index.css'
import AttributeSpecField from './AttributeSpecField'

class ProductAttribute extends PureComponent {
  render () {
    const {
      className,
      proposalType,
      triggerFieldChange,
      struDataAttrCluster = {},
      syncTransientAttributes,
      meta,
      showErrorOnActive,
      mustShowFormError,
      isClusterNotFound
    } = this.props

    return (
      <div
        data-role='product-attribute'
        className={cx(styles.ProductAttribute, className)}
        ref={r => (this.productAttribute = r)}
      >
        <AttributeSpecField
          proposalType={proposalType}
          syncTransientAttributes={syncTransientAttributes}
          triggerFieldChange={triggerFieldChange}
          struDataAttrCluster={struDataAttrCluster}
          meta={meta}
          showErrorOnActive={showErrorOnActive}
          mustShowFormError={mustShowFormError}
          isClusterNotFound={isClusterNotFound}
        />
      </div>
    )
  }
}

ProductAttribute.propTypes = {
  triggerFieldChange: PropTypes.func.isRequired,
  struDataAttrCluster: PropTypes.object
}

export default ProductAttribute
